<!--
  2021-09-29 C007 实现新的Landing模板
-->
<template>
  <table border="0" align="center" cellpadding="0" cellspacing="0" width="100%" style="width:100%;max-width:100%;">
    <tbody>
    <tr><!-- Outer Table -->
      <td align="center" bgcolor="#F0F0F0">
        <table border="0" align="center" cellpadding="0" cellspacing="0" class="row" role="presentation" width="100%"
               style="">
          <!-- simpli-header-2 -->
          <tbody>
          <tr>
            <td align="center">
              <table border="0" align="center" cellpadding="0" cellspacing="0" class="row container-padding10"
                     role="presentation" style="">
                <!-- bg-image -->
                <tbody>
                <tr>
                  <td align="center" bgcolor="#F4F4F4" style="border-radius:36px;">
                    <div>
                      <!-- simpli-header-bg-image -->
                      <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%"
                             style="width:100%;max-width:100%;">
                        <tbody>
                        <tr>
                          <td align="center"
                              style="background-size:cover;background-position:center top;border-radius:36px;">
                            <img
                              src="https://ik.imagekit.io/m5gbqmn508q/appicial_home/Pgebet/casino-banner_P9q5Y85YVo.png"
                              style="border: none;width: 100%;border-radius: 0px;display: block"/>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <!-- simpli-header-bg-image -->
                    </div>
                  </td>
                </tr>
                <!-- bg-image -->
                </tbody>
              </table>
              <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation"
                     class="row container-padding25" style="position: relative; top: -20px">
                <!-- basic-info -->
                <tbody>
                <tr>
                  <td>
                    <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row" width="100%" style="">
                      <tbody><tr>
                        <td valign="bottom" class="container-padding" style="">
                          <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="width:100%;max-width:100%;">
                            <tbody><tr>
                              <td align="center" bgcolor="#FFFFFF" height="40" style="height:40px;font-size:40px;line-height:36px;border-radius:36px 36px 0 0;" class="container-padding">&nbsp;</td>
                            </tr>
                            </tbody></table>
                        </td>
                      </tr>
                      </tbody></table>
                  </td>
                </tr>
                <tr>
                  <td align="center" bgcolor="#FFFFFF"
                      style="border-radius:0 0 36px 36px;border-bottom:solid 6px #DDDDDD;">
                    <!-- content -->
                    <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation"
                           class="row container-padding" style="">
                      <tbody>
                      <tr>
                        <td align="center">
                          <!-- Button -->
                          <table border="0" cellspacing="0" cellpadding="0" role="presentation" align="center"
                                 class="center-float">
                            <tbody>
                            <tr>
                              <td align="center" bgcolor="#48ac48" style="border-radius:6px;">
                                <table border="0" cellpadding="0" cellspacing="0" align="center">
                                <tr>
                                  <td align="center" width="35"></td>
                                  <td align="center" height="50" style="height:50px;">
                                    <div @click="download"
                                       style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:16px;line-height:20px;font-weight:700;font-style:normal;color:#FFFFFF;text-decoration:none;text-transform: uppercase;letter-spacing:0px;padding:15px 35px 15px 35px;display:inline-block;"><span>Download App</span></div>
                                  </td>
                                  <td align="center" width="35"></td>
                                </tr>
                                </table>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                          <!-- Buttons -->
                        </td>
                      </tr>
                      <tr>
                        <td height="40" style="font-size:15px;line-height:15px;">&nbsp;</td>
                      </tr>
                      <tr>
                        <td class="center-text" align="center"
                            style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:16px;line-height:26px;font-weight:300;font-style:normal;color:#333333;text-decoration:none;letter-spacing:0px;padding: 0 10px">

                          <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">{{ $t('lang.landing2.text1') }} <strong>{{ $t('lang.landing2.text2') }}</strong>. <br>{{ $t('lang.landing2.text3') }} <strong>{{ $t('lang.landing2.text4') }}</strong>. {{ $t('lang.landing2.text5') }} <strong>{{ $t('lang.landing2.text6') }}</strong> {{ $t('lang.landing2.text7') }} <strong>{{ $t('lang.landing2.text8') }}</strong> {{ $t('lang.landing2.text9') }}.</p>
                            <p style="margin: 0px; padding: 0px;"></p>
                            <p style="margin: 0px; padding: 0px;"><br></p>
                            <p style="margin: 0px; padding: 0px;">
                            </p>
                            <p style="margin: 0px; padding: 0px;">
                            </p>
                            <p style="margin: 0px; padding: 0px;">
                            </p></div>
                        </td>
                      </tr>
                      <tr>
                        <td height="25" style="font-size:25px;line-height:25px;">&nbsp;</td>
                      </tr>
                      <!-- <tr>
                        <td height="40" style="font-size:40px;line-height:40px;">&nbsp;</td>
                      </tr> -->
                      </tbody>
                    </table>
                    <!-- content -->
                  </td>
                </tr>
                <tr>
                  <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%"
                         style="width:100%;max-width:100%;">
                    <!-- simpli-footer -->
                    <tbody>
                    <tr>
                      <td align="center">
                        <!-- Content -->
                        <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation"
                               class="row container-padding" style="">
                          <tbody>
                          <tr>
                            <td height="50" style="font-size:50px;line-height:50px;">&nbsp;</td>
                          </tr>
                          <tr>
                            <td class="center-text" align="center"
                                style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:24px;line-height:32px;font-weight:400;font-style:normal;color:#999999;text-decoration:none;letter-spacing:0px;">

                              <div style="margin: 0px; padding: 0px;">
                                {{ $t('lang.landing2.contact') }} <strong>#{{ $t('lang.landing2.pgeBet') }}</strong></div>

                            </td>
                          </tr>
                          <tr>
                            <td height="20" style="font-size:20px;line-height:20px;">&nbsp;</td>
                          </tr>
                          <tr>
                            <td align="center">
                              <!-- Social Icons -->
                              <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" width="100%"
                                     style="width:100%;max-width:100%;">
                                <tbody>
                                <tr>
                                  <td align="center">
                                    <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation">
                                      <tbody>
                                      <tr>
                                        <td class="rwd-on-mobile" align="center" valign="middle" height="36" style="height:36px;">
                                          <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation">
                                            <tbody>
                                            <tr>
                                              <td width="10"></td>
                                              <td align="center">
                                                <a href="https://www.facebook.com/PGEbet" target="_blank"><img
                                                  style="width:36px;border:0px;display:inline!important;"
                                                  src="https://modulescomposer.s3.us-east-2.amazonaws.com/simpli/Facebook.png"
                                                  width="36" border="0" alt="icon"></a>
                                              </td>
                                              <td width="10"></td>
                                            </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                              <!-- Social Icons -->
                            </td>
                          </tr>
                          <tr>
                            <td height="40" style="font-size:40px;line-height:40px;">&nbsp;</td>
                          </tr>
                          <tr>
                            <td align="center">
                              <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row"
                                     style="">
                                <tbody>
                                <tr>
                                  <td class="center-text" align="center"
                                      style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:16px;line-height:24px;font-weight:480;font-style:normal;color:#666666;text-decoration:none;letter-spacing:0px;">

                                    <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">
                                      {{ $t('lang.landing2.forAndroid') }}
                                    </p></div>

                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <!--<tr>
                            <td align="center">
                              <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation">
                                <tbody>
                                <tr class="center-on-mobile">
                                  <td class="rwd-on-mobile center-text" align="center"
                                      style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;line-height:24px;font-weight:400;font-style:normal;color:#333333;text-decoration:none;letter-spacing:0px;">
                                    <a href="#"
                                       style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;font-weight:400;line-height:24px;color:#333333;text-decoration:none;">UNSUBSCRIBE</a>
                                  </td>
                                  <td class="hide-mobile" align="center" valign="middle">
                                    <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation">
                                      <tbody>
                                      <tr>
                                        <td width="5"></td>
                                        <td class="center-text" align="center"
                                            style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;line-height:24px;font-weight:400;font-style:normal;color:#333333;text-decoration:none;letter-spacing:0px;">
                                          |
                                        </td>
                                        <td width="5"></td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td class="rwd-on-mobile center-text" align="center"
                                      style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;line-height:24px;font-weight:400;font-style:normal;color:#333333;text-decoration:none;letter-spacing:0px;">
                                    <a href="#"
                                       style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;font-weight:400;line-height:24px;color:#333333;text-decoration:none;">WEB
                                      VERSION</a>
                                  </td>
                                  <td class="hide-mobile" align="center" valign="middle">
                                    <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation">
                                      <tbody>
                                      <tr>
                                        <td width="5"></td>
                                        <td class="center-text" align="center"
                                            style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;line-height:24px;font-weight:400;font-style:normal;color:#333333;text-decoration:none;letter-spacing:0px;">
                                          |
                                        </td>
                                        <td width="5"></td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td class="rwd-on-mobile center-text" align="center"
                                      style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;line-height:24px;font-weight:400;font-style:normal;color:#333333;text-decoration:none;letter-spacing:0px;">
                                    <a href="#"
                                       style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;font-weight:400;line-height:24px;color:#333333;text-decoration:none;">SEND
                                      TO A FRIEND</a>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>-->
                          <tr>
                            <td height="26" style="border-bottom:4px dotted #E4E4E4;font-size:26px;line-height:26px;">&nbsp;</td>
                          </tr>
                          <tr>
                            <td height="30" style="font-size:30px;line-height:30px;">&nbsp;</td>
                          </tr>
                          <tr>
                            <td align="center">
                              <table border="0" align="center" cellpadding="0" cellspacing="0" role="presentation" class="row"
                                     style="">
                                <tbody>
                                <tr>
                                  <td class="center-text" align="center"
                                      style="font-family:'Catamaran',Arial,Helvetica,sans-serif;font-size:14px;line-height:24px;font-weight:480;font-style:normal;color:#666666;text-decoration:none;letter-spacing:0px;">
                                    <div style="margin: 0px; padding: 0px;"><p style="margin: 0px; padding: 0px;">
                                      2021 PGEbet Ltd. All Rights Reserved.</p>
                                      <p style="margin: 0px; padding: 0px;">
                                        Address: Eden Island, Mahe, Seychelles.</p>
                                      <p style="margin: 0px; padding: 0px;"><br></p>
                                      <p style="margin: 0px; padding: 0px;">
                                      </p></div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td height="50" style="font-size:50px;line-height:50px;">&nbsp;</td>
                          </tr>
                          </tbody>
                        </table>
                        <!-- Content -->
                      </td>
                    </tr>
                    <!-- simpli-footer -->
                    </tbody>
                  </table>
                </tr>
                <!-- basic-info -->
                </tbody>
              </table>
            </td>
          </tr>
          <!-- simpli-header-2 -->
          </tbody>
        </table>
      </td>
    </tr><!-- Outer-Table -->
    </tbody>
  </table>
</template>

<script>
import logo from '@/assets/images/common/logo1.svg'
import paymentLogo from '@/assets/images/common/payment_logo.png'
import btn1 from '@/assets/images/common/landing_button1.gif'
import btn2 from '@/assets/images/common/landing_button2.gif'
import text from '@/assets/images/common/text.png'
import {LogUtils, adListener} from '@/utils'
export default {
  name: 'Template2',
  data () {
    return {
      logo,
      text,
      btn: '',
      btn1,
      btn2,
      paymentLogo
    }
  },
  mounted () {
    adListener('PageViewLanding')
    switch (this.$route.name) {
      case 'Landing1':
        this.btn = btn1
        break
      case 'Landing2':
        this.btn = btn2
        break
      case 'Landing3':
        this.btn = btn1
        break
      case 'Landing4':
        this.btn = btn2
        break
    }
    this.download()
  },
  methods: {
    download () {
      LogUtils.downloadApp('ClickTopDown')
    }
  }
}
</script>

<style lang="less">
#app {
  #viewContainer {
    padding-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Landing/template2.vue